import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import ExternalLinkIconImg from './icons/outline-launch-24px.svg';

const A = styled.a`
  padding-right: 1.2em;

  background-size: 1em 1em;
  background-repeat: no-repeat;
  background-position: right;
  background-image: url(${ExternalLinkIconImg});
`;

export const ExternalLink = ({
  target,
  href,
  className,
  rel,
  children,
}) => (
  <A href={href} target={target} rel={rel} className={className}>
    { children || href }
  </A>
);

ExternalLink.propTypes = {
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  rel: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

ExternalLink.defaultProps = {
  target: '_blank',
  rel: 'noopener nofollow external',
  className: undefined,
  children: undefined,
};



// WEBPACK FOOTER //
// ./src/components/ExternalLink/ExternalLink.js